module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAAXNSR0IArs4c6QAAAGZQTFRFAAAAKioqGjMzJyc7KCg2JiYzKio1KSkxKCgwJCovJCkzKCw0JCsyJyowJikzJikyJSoyJykyJioxJisyJyozJyoyJiozJioyJikyJioyJioyJioyJioxJioyJioyJioyJioyJioyjXblQwAAACF0Uk5TAAYKDRMUGB8gKzJATU9QUWBwh5WXwM/Q0dfY4Oju8fj69SXwnwAAALlJREFUOMvV08kOgyAQgGFcahVcqi1Qd+f9X7LAJC4Inrx0ThP/T0hMJOTuybLrXi5Led0BluKyfyX4z9D9EfuF6YR4he6xXjxCdRnj6hS77hSHroSwRHXsJ3HqlnB0FBWuhaujMF89nKBNo8DuQZS2MIVqS0BPbYPaPE70+t4AZWroBj6In7RD0Ji3oEHQ0XQ9TyDgIDmXwBGI3YUrYISwPwZjr2aGoe8HmPU+WsAxe5C/HJPf9Df/AF3iHeNB1P/rAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/right-nav/user.png
// module id = 782
// module chunks = 1